import { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { FileText, LayoutDashboard, MessageSquare, ClipboardList, Sparkles } from 'lucide-react';
import { Header } from './Header';
import { cn } from '@/lib/utils';

const userNav = [
  { to: '/app', label: 'Dashboard', icon: LayoutDashboard, end: true },
  { to: '/app/demanda/nova', label: 'Nova demanda', icon: Sparkles },
  { to: '/app/tarefas', label: 'Tarefas', icon: ClipboardList },
  { to: '/app/contratos', label: 'Contratos', icon: FileText },
  { to: '/app/contratos/novo', label: 'Novo contrato', icon: FileText },
];

const lawyerNav = [
  { to: '/lawyer', label: 'Dashboard', icon: LayoutDashboard, end: true },
  { to: '/lawyer/tarefas', label: 'Tarefas', icon: MessageSquare },
  { to: '/lawyer/precos', label: 'Preços', icon: FileText },
  { to: '/lawyer/perfil', label: 'Perfil', icon: FileText },
  { to: '/lawyer/financeiro', label: 'Financeiro', icon: FileText },
];

export function AppShell({ role, children }: { role: 'users' | 'lawyers'; children: ReactNode }) {
  const items = role === 'lawyers' ? lawyerNav : userNav;
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <div className="flex flex-1">
        <aside className="hidden lg:flex w-64 flex-col border-r border-border/60 bg-surface px-4 py-8 gap-1">
          {items.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end ?? false}
              className={({ isActive }) =>
                cn(
                  'inline-flex items-center gap-3 rounded-md px-3 py-2 text-sm transition-colors',
                  isActive
                    ? 'bg-muted/60 text-foreground font-medium'
                    : 'text-muted-foreground hover:text-foreground hover:bg-muted/40',
                )
              }
            >
              <item.icon className="h-4 w-4" />
              {item.label}
            </NavLink>
          ))}
        </aside>
        <main className="flex-1 px-6 py-8 lg:px-12">{children}</main>
      </div>
    </div>
  );
}
